import { useTheme } from '@emotion/react';
import { SvgIcon } from '@mui/material';
import React from 'react'

export default function SelectArrow() {
    const theme = useTheme();
    const primaryColor = theme.palette.text.primary;
    return (
        <SvgIcon viewBox="0 0 10 7" fontSize='10' sx={{mr:0.5}}>
            <svg width="2" height="2"  fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 1.53369L5 5.53369L9 1.53369" stroke={primaryColor} stroke-width="0.5" stroke-linecap="round" />
            </svg>
        </SvgIcon>
    )
}
